var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarisa = function SvgMarisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 90,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "#EC008C",
    rx: 45,
    transform: "matrix(-1 0 0 1 90.5 0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.509 32.72C31.49 30.965 34.277 30 37.357 30c3.016 0 5.922 1.111 7.974 3.049l.17.16.17-.16C47.725 31.112 50.63 30 53.646 30c3.08 0 5.867.966 7.849 2.72 1.898 1.678 3.074 3.422 3.074 6.921v20.336H59.01V39.64c0-2.674-2.357-4.769-5.366-4.769s-5.365 2.095-5.365 4.77v20.335h-5.558V39.64c0-2.674-2.357-4.769-5.365-4.769-3.01 0-5.366 2.095-5.366 4.77v20.335h-5.556l-.002-20.336c.001-3.498 1.177-5.242 3.076-6.922"
  })));
};
export default SvgMarisa;